export function validatePassword(input: string) {
	return (
		input.length > 8 && /[A-Z]/.test(input) && /[a-z]/.test(input) && /[^A-z0-9]/.test(input) && /[0-9]/.test(input)
	);
}
